import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { TextLabel } from 'uiToolkitV1/Typography';

import { COLOR_MAP_GOALS } from '../../../constants';
import { ObjectiveProgressBarAgGrid } from '../ObjectiveProgressBarAgGrid';

const countString = ({ label, count }) => `${label}: ${count}`;

export const LabelText = ({ progressCount }) => {
  const { ON_TRACK, OFF_TRACK, AT_RISK, CLOSED } = progressCount ?? {};

  const compiled = {
    ON_TRACK: ON_TRACK ? countString({ label: 'On-Track', count: progressCount?.ON_TRACK?.count }) : '',
    OFF_TRACK: OFF_TRACK ? countString({ label: 'Off-Track', count: progressCount?.OFF_TRACK?.count }) : '',
    AT_RISK: AT_RISK ? countString({ label: 'At-Risk', count: progressCount?.AT_RISK?.count }) : '',
    CLOSED: CLOSED ? countString({ label: 'Closed', count: progressCount?.CLOSED?.count }) : '',
  };

  return (
    <Flex alignItems="center">
      {COLOR_MAP_GOALS.map(({ barColor, key }) => (
        <TextLabel letterSpacing="-0.2px" mr="4px" color={barColor} key={key}>
          {compiled[key]}
        </TextLabel>
      ))}
    </Flex>
  );
};

const ButtonContainer = styled('div')`
  display: none;
  visibility: hidden;
  right: 22px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

export const OkrProgress = ({ data }) => {
  const { progress, type, avgProgressPercentage, unMasked, progressLevel, closureStatus } = data ?? {};
  const { barDistribution, progressCount } = progress ?? {};
  const isObjective = type === 'OBJECTIVE';
  if (!unMasked) {
    return null;
  }

  return (
    <Flex w="100%" h="100%" alignItems="center">
      {isObjective && (
        <Flex w="100%" h="100%" justifyContent="center" flexDir="column">
          <ObjectiveProgressBarAgGrid
            data={progressCount ?? {}}
            percentageValue={avgProgressPercentage}
            progressLevel={progressLevel}
            goalClosureStatus={closureStatus}
          />
          {/* <Box textAlign={'left'}>
              <LabelText progressCount={progressCount} />
            </Box> */}
        </Flex>
      )}
      {!isObjective && (
        <Flex w="100%" h="100%" justifyContent="center" flexDir="column">
          <ObjectiveProgressBarAgGrid
            data={progressCount ?? {}}
            percentageValue={avgProgressPercentage}
            isGoalProgressbar
            progressLevel={progressLevel}
            goalClosureStatus={closureStatus}
          />
        </Flex>
      )}
    </Flex>
  );
};

const ObjectiveProgressCell = ({ data }) => (
  <Box height="100%" position="relative">
    <OkrProgress data={data} />
  </Box>
);

export { ObjectiveProgressCell };
